export default "__VITE_ASSET__DMz$y7Iy__"